import React, { FC, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { createSettingHoliday, fetchSettingHoliday, fetchSettingHolidayDetail } from '../../../../states/containers/setting/systemSlice'
import { Link, useParams } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { URL } from '../../../constants/url'
import { LangValue } from '../../../../states/types/common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MemberListModule from '../../../components/common/MemberListModule'
import { RequestPostSettingHoliday, SettingHolidayMember } from '../../../../states/types/setting'
import LoadingSquare from '../../../components/common/LoadingSquare'
import { useAlert } from 'react-alert'
import MonthlyCalendar from '../../../components/setting/holidaySchedule/MonthlyCalendar'
import { format, nowDate } from '../../../../utils/date'
import SettingHolidayModal from '../../../components/common/SettingHolidayModal'
import { RootState } from '../../../../states/containers/store'

const Index: FC = () => {
  const dispatch = useDispatch()
  const alert = useAlert()
  const { language } = useParams<{ language: LangValue }>()

  const {
    login,
  } = useSelector<RootState, RootState>((state: RootState) => (state))

  const [originMemberList, setOriginMemberList] = useState<SettingHolidayMember[]>([])

  const [isDisplayModal, setIsDisplayModal] = useState<boolean>(false)
  const [targetMembers, setTargetMembers] = useState<SettingHolidayMember[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false)

  const [isHoliday, setIsHoliday] = useState<boolean>(true)
  const [holidayList, setHolidayList] = useState<string[][]>([])
  const [targetYear, setTargetYear] = useState<number>(Number(nowDate("YYYY")))
  const [isSubmit, setIsSubmit] = useState<boolean>(false)
  const [isClear, setIsClear] = useState<boolean>(false)
  const [quickChange, setQuickChange] = useState<string>("")
  const [tmpHolidays, setTmpHolidays] = useState<string[][]>([])

  const [memberHolidays, setMemberHolidays] = useState<string[]>([])

  const openUpdateModal = (memberIds: number[]) => {
    setTargetMembers(originMemberList.filter((v) => memberIds.includes(v.id)))
    dispatch(
      fetchSettingHolidayDetail(
        {
          year: targetYear.toString(),
          id: memberIds[0].toString(),
        },
        (result) => {
          setMemberHolidays(result.holidays)
          setIsDisplayModal(true)
        },
      ),
    )
    setIsDisplayModal(true)
  }

  const closeModal = () => {
    setTargetMembers([])
    setIsDisplayModal(false)
  }

  const changeSettingHoliday = () => {
    setIsHoliday((v) => !v)
  }

  const changeHoliday = (holidays: string[]) => {
    setTmpHolidays((cur) => [...cur, holidays])
  }

  const clickQuickHolidaySetting = (type: string) => {
    setQuickChange(type)
  }

  const clearNotWorkdayList = () => {
    setIsClear(true)
  }

  const buildQuickHolidaySettingBox = () => (
    <div
      style={{
        border: "solid 1px #CCCCCC",
        borderRadius: "4px",
        marginBottom: "16px",
        backgroundColor: "#FFFFFF",
        padding: "8px",
      }}
    >
      <div
        style={{
          marginBottom: "8px",
        }}
      >
        クイック選択
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sss")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundImage: "linear-gradient(135deg, rgb(255 241 241), rgb(255 241 241) 20%, rgb(230, 245, 255))",
            }}
          >
            {`${targetYear}年の土日祝`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sun")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の日曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("mon")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の月曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("tue")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の火曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("wed")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の水曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("thu")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の木曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("fri")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の金曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sat")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#e6f5ff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の土曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("holiday")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の祝日`}
          </button>
        </div>
      </div>
    </div>
  )

  const changeTargetYear = (year: number) => {
    setTargetYear(year)
  }

  const buildCheckBox = (value: boolean) => (
    value ? (
      <FontAwesomeIcon
        icon={["fas", "check-square"]}
        style={{ color: "#008800" }}
        fixedWidth
      />
    ) : (
      <FontAwesomeIcon
        icon={["far", "square"]}
        style={{ color: "#999999" }}
        fixedWidth
      />
    )
  )

  const modCompanyHoliday = (holidays: string[]) => {
    const param: RequestPostSettingHoliday = { change_common_setting: true }
    param.year = targetYear.toString()
    param.enabled = isHoliday
    if (isHoliday) {
      param.holidays = holidays
    }
    dispatch(
      createSettingHoliday(
        param,
        () => {
          setIsSubmit(false)
          setTmpHolidays([])
          alert.success("会社設定を変更しました")
          setHolidayList(
            Array(12).fill(null).map((_v, i) => (
              holidays.filter((w) => Number(format(w, "M")) === i + 1)
            )),
          )
        },
      ),
    )
  }

  const modMemberHoliday = (data: { memberIds: number[], holidays: string[], useCommonSetting: boolean, isHoliday: boolean }) => {
    const param: RequestPostSettingHoliday = {
      change_common_setting: false,
      member_ids: data.memberIds,
      year: targetYear.toString(),
      enabled: data.isHoliday,
    }
    if (data.useCommonSetting) {
      param.use_common_setting = true
    } else {
      param.use_common_setting = false
    }
    if (data.isHoliday) {
      param.holidays = data.holidays
    }
    dispatch(
      createSettingHoliday(
        param,
        () => {
          alert.success("個別設定を変更しました")
          setOriginMemberList((cur) => cur.map((v) => (
            data.memberIds.includes(v.id)
              ? {
                ...v,
                use_common_setting: param.use_common_setting || v.use_common_setting,
                holiday_count: data.holidays.length,
                enabled: data.isHoliday,
              }
              : v
          )))
        },
      ),
    )
  }

  const submit = () => {
    if (isHoliday) {
      setIsSubmit(true)
    } else {
      modCompanyHoliday([])
    }
  }

  useEffect(() => {
    if (tmpHolidays.length !== 12 || !isSubmit) return
    modCompanyHoliday(tmpHolidays.flat())
  }, [tmpHolidays, isSubmit])

  useEffect(() => {
    if (!isClear) return
    setIsClear(false)
  }, [isClear])

  useEffect(() => {
    if (!quickChange.length) return
    setQuickChange("")
  }, [quickChange])

  useEffect(() => {
    setIsLoading(true)
    dispatch(fetchSettingHoliday(
      {
        year: targetYear.toString(),
      },
      (result) => {
        setOriginMemberList(result.members)
        setHolidayList(
          Array(12).fill(null).map((_v, i) => (
            result.common.holidays.filter((w) => Number(format(w, "M")) === i + 1)
          )),
        )
        setIsHoliday(result.common.enabled ?? true)
        setTimeout(() => {
          setIsLoading(false)
        }, 1000)
      },
    ))
  }, [])

  useEffect(() => {
    if (isLoading) return
    setIsDetailLoading(true)
    dispatch(fetchSettingHoliday(
      {
        year: targetYear.toString(),
      },
      (result) => {
        setOriginMemberList(result.members)
        setHolidayList(
          Array(12).fill(null).map((_v, i) => (
            result.common.holidays.filter((w) => Number(format(w, "M")) === i + 1)
          )),
        )
        setTimeout(() => {
          setIsDetailLoading(false)
        }, 1000)
      },
    ))
  }, [targetYear])

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - ${login.role_name === "管理者" ? "管理者" : "共通"}設定 - 休日設定`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        <Link
          to={setPath(URL.SETTING_COMMON.path, language)}
        >
          {`${login.role_name === "管理者" ? "管理者" : "共通"}設定`}
        </Link>
        &nbsp;&gt;&nbsp;
        休日設定
        &nbsp;
      </section>
      <section className="page_header">
        <h1>休日設定</h1>
      </section>
      <section className="page_description">
        <p>
          日付クリックで簡単に休日を設定することができます。
        </p>
      </section>
      {
        isLoading ? (
          <LoadingSquare>
            <>
              情報を取得しています…
            </>
          </LoadingSquare>
        ) : (
          <>
            {
              login.role_target_restriction || (
                <section className="page_contents content-area">
                  <div className="content-block">
                    <div className="block-header">
                      <div className="title">
                        会社全体の設定
                      </div>
                    </div>
                    <div className="block-detail">
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            border: "solid 1px #CCCCCC",
                            borderRadius: "4px",
                            backgroundColor: "#fffafa",
                            padding: "16px",
                            display: "flex",
                            flexFlow: "column",
                            gap: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              backgroundColor: "#f3f3f3",
                              padding: "8px",
                              margin: "-16px -16px 0 -16px",
                              borderRadius: "4px 4px 0 0",
                              marginBottom: "8px",
                            }}
                          >
                            <div>
                              休日設定
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                userSelect: "none",
                                cursor: "pointer",
                              }}
                              onClick={changeSettingHoliday}
                              role="none"
                            >
                              {buildCheckBox(isHoliday)}
                              休日を設定する
                            </div>
                          </div>
                          {
                            isHoliday && (
                              <>
                                <div
                                  style={{
                                    border: "solid 1px #FF0000",
                                    borderRadius: "4px",
                                    padding: "8px",
                                    color: "#FF0000",
                                    backgroundColor: "#ffeeee",
                                  }}
                                >
                                  ※ 休日設定は計測時間を制限するものではありません。
                                  {
                                    login.role_permission?.measurement_setting && (
                                      <>
                                        計測時間の設定は
                                        <Link
                                          to={setPath(URL.SETTING_MEASUREMENT.path, "ja")}
                                          className=""
                                        >
                                          こちら
                                        </Link>
                                      </>
                                    )
                                  }
                                </div>
                                <div
                                  style={{
                                    position: "relative",
                                    display: "flex",
                                    flexFlow: "column",
                                    gap: "8px",
                                  }}
                                >
                                  {
                                    isDetailLoading && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          width: "100%",
                                          height: "100%",
                                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                                          zIndex: "2000",
                                        }}
                                      >
                                        <LoadingSquare>
                                          <>
                                            しばらくお待ちください
                                          </>
                                        </LoadingSquare>
                                      </div>
                                    )
                                  }
                                  {buildQuickHolidaySettingBox()}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "16px",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        borderRadius: "4px",
                                        backgroundColor: "#fffafa",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "10px",
                                        padding: "8px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "#FF0000",
                                          width: "12px",
                                          height: "12px",
                                          borderRadius: "50%",
                                          opacity: "0.2",
                                        }}
                                      />
                                      ：休日
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => changeTargetYear(targetYear - 1)}
                                    >
                                      <FontAwesomeIcon icon={['fas', 'angle-left']} />
                                    </button>
                                    <div>
                                      {`${targetYear}年`}
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => changeTargetYear(targetYear + 1)}
                                    >
                                      <FontAwesomeIcon icon={['fas', 'angle-right']} />
                                    </button>
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={clearNotWorkdayList}
                                        style={{
                                          border: "solid 1px #CCCCCC",
                                          borderRadius: "4px",
                                          backgroundColor: "#FFFFFF",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <FontAwesomeIcon icon={['fas', 'ban']} />
                                        {`${targetYear}年の休日をすべて解除`}
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "8px",
                                      zIndex: "1999",
                                    }}
                                  >
                                    {
                                      Array(12).fill(null).map((_v, i) => (
                                        <React.Fragment key={`${targetYear}_${i + 1}`}>
                                          <MonthlyCalendar
                                            targetYear={targetYear}
                                            targetMonth={i + 1}
                                            holidayList={holidayList[i]}
                                            submitCallback={(value) => changeHoliday(value)}
                                            isSubmit={isSubmit}
                                            isClear={isClear}
                                            quickChange={quickChange}
                                          />
                                        </React.Fragment>
                                      ))
                                    }
                                  </div>
                                </div>
                              </>
                            )
                          }
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          type="button"
                          className="mt-4 button"
                          onClick={submit}
                        >
                          設定する
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              )
            }
            <MemberListModule
              originMemberList={originMemberList.map((v) => ({ ...v, value: v.enabled ? `${v.holiday_count}日` : "設定しない" }))}
              statusList={[]}
              commonValue={isHoliday ? `${holidayList.flat().length}日` : "設定しない"}
              valueLabel="休日設定"
              type="direct"
              modalOpenCallback={(memberIds) => openUpdateModal(memberIds)}
            />
            <SettingHolidayModal
              targetMemberList={targetMembers}
              isDisplayModal={isDisplayModal}
              submitCallback={
                (data: { memberIds: number[], holidays: string[], useCommonSetting: boolean, isHoliday: boolean }) => modMemberHoliday(data)
              }
              closeCallback={closeModal}
              targetYear={targetYear}
              memberHolidays={memberHolidays}
            />
          </>
        )
      }
    </section>
  )
}

export default Index
